// actions/tutorial deals with dispatching types, payloads
// and promises thus uses try catch on async await code...
// I suspect this could be refactored to use .then() syntax

import {
  CREATE_TUTORIAL,
  RETRIEVE_TUTORIALS,
  UPDATE_TUTORIAL,
  DELETE_TUTORIAL,
  DELETE_ALL_TUTORIALS,
} from "./types";

// tutorial.service provides all the routing and http verbs via http-common which is just an axios create object for our baseURL and headers for json format
import TutorialDataService from "../services/tutorial.service";

// retrieve gets all of the existing tutorials
// it requires no arguments
// get.("/tutorials")
export const retrieveTutorials = () => async (dispatch) => {
  try {
    const res = await TutorialDataService.getAll();
    dispatch({
      type: RETRIEVE_TUTORIALS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};

// create takes all required fields as arguments
// and attempts a dispatch with the correct types,
// which are just convenience strings
// get.("/tutorials", data) and payload becomes response data
export const createTutorial =
  (title, description, author) => async (dispatch) => {
    try {
      const res = await TutorialDataService.create({
        title,
        description,
        author,
      });
      dispatch({
        type: CREATE_TUTORIAL,
        payload: res.data,
      });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };

// update requires 2 arguments, data and an id to update with
// .put(`/tutorials/${id}`, data) and payload becomes data
export const updateTutorial = (id, data) => async (dispatch) => {
  try {
    const res = await TutorialDataService.update(id, data);
    dispatch({
      type: UPDATE_TUTORIAL,
      payload: data,
    });
    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

//
// .delete(`/tutorials/${id}`) and payload becomes id
export const deleteTutorial = (id) => async (dispatch) => {
  try {
    await TutorialDataService.delete(id);
    dispatch({
      type: DELETE_TUTORIAL,
      payload: { id },
    });
  } catch (err) {
    console.log(err);
  }
};

// delete all takes no arguments bc ultimately we just return
// an empty array
// .delete(`/tutorials`) and payload becomes response.data
export const deleteAllTutorials = () => async (dispatch) => {
  try {
    const res = await TutorialDataService.deleteAll();
    dispatch({
      type: DELETE_ALL_TUTORIALS,
      payload: res.data,
    });
    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

// find requires only a title, thus currently can only find by title
// aka no finding by other fields like author
// .get(`/tutorials?title=${title}`);
export const findTutorialsByTitle = (title) => async (dispatch) => {
  try {
    const res = await TutorialDataService.findByTitle(title);
    dispatch({
      type: RETRIEVE_TUTORIALS,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};

// export const findTutorialsByAuthor = (author) => async (dispatch) => {
//   try {
//     const res = await TutorialDataService.findByAuthor(author);
//     dispatch({
//       type: RETRIEVE_TUTORIALS,
//       payload: res.data,
//     });
//   } catch (err) {
//     console.log(err);
//   }
// };
